<script>
	// Stores 
	import { alt } from '../store.js';  

	// Componentes
	import { link }		from "svelte-routing";
	import PageHeader	from './../components/PageHeader.svelte';

	// Code
	let titlePage = 'Garantias Locatícias';    
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>    
<div class="container">
	<p>Confira os tipos de garantias locatícias disponíveis e a o que é necessário em cada uma delas.</p>
	<hr>
	<div class="box-itens-icon grid grid-size--1 grid-size-sm--1">

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Fiador</h2>
				<p>
					Documentos exigidos conforme relação Pessoa Física/Jurídica.
				</p>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Título de Capitalização</h2>
				<p>A Porto Seguro Capitalização oferece o PortoCap Aluguel, título de capitalização como alternativa na hora de alugar um imóvel comercial ou residencial. A contratação é rápida e segura, o valor é equivalente a 12 vezes o valor do aluguel mais as taxas do imóvel a ser locado.</p>
			</div>
		</div>

		<div class="item">			
			<div class="infos">
				<h2 class="title color-primary">Seguro Fiança</h2>
				<p>Preencher cadastro com documentação exigida, entrar em contato com Administradora para orientação do preenchimento do cadastro junto a Porto Seguro.</p>
				<p>Obs: Análise de cadastro será feita através da Porto Seguro Administração.</p>
			</div>
		</div>

	</div>
	<br />

	<p>Em caso de dúvidas, entre em <a href="/contato" use:link>contato</a> conosco, nossa equipe está à disposição para auxiliar.</p>
	<div class="button text-center mt-40">
		<a href="/documentacao-necessaria" use:link replace title="Confira a documentação necessária para locação" class="btn btn-secondary">Confira a Documentação para Locação <div class="arrow-animate"><i class="far fa-arrow-right"></i></div> </a>
	</div>

</div>